import {
  AdditionalProduct,
  AdditionalService,
  DeliveryConfig,
  DischargeTime,
  IElement,
  LoadSize,
  PumpCapacity,
  SlumpType,
  TimePerLoad,
  TransportMethod,
  UnloadType,
} from '../order-management';

export interface OrderItemProfile {
  kicker: boolean;
  slump: number;
  slumpType?: SlumpType;
  additionalProducts?: AdditionalProduct[];
  additionalServices?: AdditionalService[];
  transportMethod?: TransportMethod;
  unloadType?: UnloadType;
  timePerLoad?: TimePerLoad;
  loadSize?: LoadSize;
  dischargeTime?: DischargeTime;
  pumpCapacity?: PumpCapacity;
  element?: IElement;
  deliveryConfigs?: DeliveryConfig[];
  additionalInfo?: string;
}
